<template>
  <div
    class="graphic-data"
    :class="{ barchart: isBar }"
  >
    <template v-if="content.graphicType === 'bar-chart'">
      <div class="graphic-legend">
        <div
          v-for="(item, index) in content.items"
          :key="index"
          class="count-indicator__count indicator"
        >
          <template v-if="item.number > 0">
            <md-tooltip md-direction="top">
              Clique para exibir as ordens de
              <br />
              serviço que estão nesse status
            </md-tooltip>
            <count-indicator
              v-if="item.visible"
              class="indicator action"
              :content="item"
              :class="{
                'highlight-status': statusHighlight[item.traceabilityStatus].highlight,
              }"
              @click.native="countIndicatorClick(item.number, item.traceabilityStatus)"
              @mouseover.native="applyHighlightOnStatus(item.traceabilityStatus)"
              @mouseout.native="removeHighlightOnStatus(item.traceabilityStatus)"
            />
          </template>
          <template v-else>
            <count-indicator
              v-if="item.visible"
              class="indicator"
              :content="item"
            />
          </template>
        </div>
        <additional-details
          v-if="content.NTOsLeft.length > 0"
          :n-t-os-left="content.NTOsLeft"
        />
      </div>
      <div class="graphic-data__chartdata">
        <template v-if="content.graphicType === 'bar-chart'">
          <bar-chart
            v-for="item in content.items"
            :key="item.text"
            :percent="getExamPercentage(item.number)"
            :bar-color="item.color"
            :action="item.traceabilityStatus"
            @clicked="onClickChild"
          />
        </template>
      </div>

      <div
        class="graphic-data__icon"
        @click="navigateToSearchIcon"
      >
        <svg-loader
          src="/static/images/icon-search-small.svg"
          css="invert(0) sepia(0%) saturate(0%)"
        />
      </div>
    </template>
    <template v-if="content.graphicType === 'doughnut'">
      <div class="graphic-data__chartdata">
        <template v-if="content.graphicType === 'bar-chart'">
          <bar-chart
            v-for="item in content.items"
            :key="item.text"
            :percent="getExamPercentage(item.number)"
            :bar-color="item.color"
          />
        </template>
        <template v-else-if="content.graphicType === 'doughnut'">
          <doughnut-chart
            class="doughnut-element"
            :chart-data="content.chartdata.datacollection"
            :options="content.options"
          />
        </template>

        <div
          v-if="content.graphicType === 'doughnut'"
          class="graphic-data__total"
        >
          <h2>{{ content.total }}</h2>
          <p>exames</p>
        </div>
      </div>
      <div class="graphic-legend">
        <div
          v-for="(item, index) in sortedNtos"
          :key="index"
          class="count-indicator__count indicator"
        >
          <md-tooltip md-direction="top">
            Clique para exibir as ordens de
            <br />
            serviço que estão nesse status
          </md-tooltip>
          <count-indicator
            v-if="item.visible"
            class="indicator action"
            :content="item"
            @click.native="pushToTraceability(item.traceabilityStatus, item)"
          />
        </div>

        <additional-details
          v-if="content.NTOsLeft.length > 0"
          :n-t-os-left="content.NTOsLeft"
        />
      </div>
      <div
        class="graphic-data__icon"
        @click="navigateToSearchIcon"
      >
        <svg-loader src="/static/images/icon-search-small.svg" />
      </div>
    </template>
  </div>
</template>

<script>
import DoughnutChart from './DoughnutChart'
import BarChart from './BarChart'
import CountIndicator from './CountIndicator'
import AdditionalDetails from './AdditionalDetails'
import strings from '@/strings'
import { mapActions } from 'vuex'
import Moment from 'moment'
import { TRACEABILITY_SEARCH_DATE, TRACEABILITY_SEARCH_NTO } from '../../../enums'

export default {
  components: {
    'bar-chart': BarChart,
    'count-indicator': CountIndicator,
    'doughnut-chart': DoughnutChart,
    'additional-details': AdditionalDetails,
  },
  props: {
    content: {
      type: Object,
      default: () => ({
        graphicType: null,
        chartdata: null,
        options: null,
        items: null,
        NTOsLeft: null,
        total: null,
      }),
      validator: function (value) {
        return value && typeof value === 'object'
      },
    },
  },
  data() {
    return {
      items: [],
      statusHighlight: strings.traceabilityStatus,
    }
  },
  computed: {
    totalExams: function () {
      return this.content.items.reduce(function (a, b) {
        return a + b.number
      }, 0)
    },
    isBar: function () {
      return this.content.graphicType === 'bar-chart'
    },
    sortedNtos: function () {
      const sortedList = [...this.content.items].sort((a, b) => {
        if (a.text === 'aguardando retirada') return -1
        if (b.text === 'aguardando retirada') return 1
        if (a.placeExecution === '' && b.placeExecution === '') return 0
        if (a.placeExecution === '') return 1
        if (b.placeExecution === '') return -1
        return a.placeExecution.localeCompare(b.placeExecution)
      })
      return sortedList
    },
  },
  mounted() {
    this.createStatusHighlightObject()
  },
  methods: {
    ...mapActions(['resetTraceabilityStore']),
    navigateToSearchIcon() {
      this.$router.push({
        path: 'traceability/search',
        query: {
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
          startDate: Moment(new Date()).clone().subtract(7, 'days').format("DD/MM/YYYY"),
          endDate:  Moment(new Date()).format("DD/MM/YYYY"),
        }
      })
    },
    navigateToSearch(traceabilityStatus) {
      this.$router.push({
        path: 'traceability/search',
        query: {
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
          status: traceabilityStatus,
          startDate: Moment(new Date()).clone().subtract(7, 'days').format("DD/MM/YYYY"),
          endDate:  Moment(new Date()).format("DD/MM/YYYY"),
        }
      })
    },
    pushToTraceability(traceabilityStatus, item){
      if (item.placeExecution) {
        this.$router.push({
          path: 'traceability/search',
          query: {
            typeOfSearch: TRACEABILITY_SEARCH_NTO,
            nto: item.placeExecution,
            status: traceabilityStatus,
          },
        })
      } else {
        this.$router.push({
          path: 'traceability/search',
          query: {
            typeOfSearch: TRACEABILITY_SEARCH_DATE,
            startDate: Moment(new Date()).clone().subtract(7, 'days').format("DD/MM/YYYY"),
            endDate:  Moment(new Date()).format("DD/MM/YYYY"),
            status: traceabilityStatus,
          },
        })
      }
    },
    countIndicatorClick(number, traceabilityStatus) {
      console.info("countIndicatorClick")
      if (number > 0) {
        this.navigateToSearch(traceabilityStatus)
      }
    },
    onClickChild(value) {
      console.info("onClickChild")
      this.navigateToSearch(value)
    },
    getExamPercentage(item) {
      if (item > 0) {
        return Math.round((item * 100) / this.totalExams)
      } else {
        return 0
      }
    },
    createStatusHighlightObject() {
      this.statusHighlight = Object.keys(strings.traceabilityStatus).reduce(
        (item, key) => {
          item[key] = { highlight: false }
          return item
        },
        {}
      )
    },
    applyHighlightOnStatus(status) {
      this.statusHighlight[status].highlight = true
    },
    removeHighlightOnStatus(status) {
      this.statusHighlight[status].highlight = false
    },
  },
}
</script>
<style lang="scss">
.barchart .count-indicator__count {
  margin-bottom: 0;
}

.graphic-data.barchart {
  width: 100%;
  overflow: hidden;
}

.graphic-data.barchart .graphic-legend {
  margin: 12px auto 0;
  text-align: right;
}

.barchart .count-indicator__count {
  padding: 0;
}

.barchart .graphic {
  width: 100%;
}

.barchart .graphic-legend {
  max-width: 70px;
}

.barchart p {
  font-size: 22px;
  line-height: 22px;
}

.barchart h2 {
  font-size: 9px;
  line-height: 1.2;
}

.barchart .bar-chart {
  max-width: 100%;
}
.barchart .graphic-data__chartdata {
  width: calc(100% - 70px);
}
.barchart .bar-chart__background {
  height: 40px;
}
.md-card {
  min-height: 100px;
}
.barchart .count-indicator__count--bigger {
  margin-bottom: 0px;
}

.graphic-data {
  display: flex;
  justify-items: center;
  flex-direction: row;
  width: 138px;

  &__total {
    transform: translateY(-3.4em) translateX(3.1em);
    width: 100px;

    h2 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 26px;
      text-align: center;
      color: #4a4a4a;
    }

    p {
      margin-top: 13px;
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }

  &__icon {
    position: absolute;
    right: 17px;
    top: 17px;
    cursor: pointer;

    .md-icon {
      width: 15px;
      height: 15px;
      min-height: 15px;
      min-width: 15px;

      & > svg {
        path {
          fill: #7f1a54;
          opacity: 1;
        }
      }
    }
  }

  #doughnut-chart {
    transform: translateY(3em) translateX(1.8em);
  }
  .progress-bar {
    margin-top: 16px;
    margin-left: 15px;
  }

  &__chartdata {
    margin-top: 1em;
    width: 100%;
  }
  .doughnut-element {
    padding-top: auto;
  }
  &__text {
    width: 50%;
    margin-left: 1em;
    display: flex;
    justify-items: center;
    flex-direction: row;
    margin-top: 1.6em;
  }
  .graphic-legend {
    width: auto;
    display: flex;
    flex-direction: column;
    margin-left: 55px;
    justify-items: right;

    .indicator {
      width: 95%;
      display: flex;
      flex-direction: column;
      margin: 0;
    }

    .action {
      cursor: pointer;

      &:hover * {
        color: #7f1a54;
      }
    }

    .highlight-status * {
      color: #7f1a54;
    }
  }
}
.graphic-legend > .indicator {
  margin-bottom: 12px !important;
}
</style>
